export enum ExternalSyncDirectionEnum {
    outbound,
    inbound,
    bidirectional
}
